import * as React from 'react';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import {  MSISDNValidationComponentHandler, MSISDNValidationComponentProps } from './msisdnvalidationcomponent';
import { MSISDNValidationCSSStyle } from './msisdnvalidationcss';

export class MSISDNValidationViewImpl extends UIComponentViewImpl<UIDataModel>
{

    numberComponent:MsisdnFloatingTextComponent;

    bindHandlers()
    {   
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
    }

    draw(props: MSISDNValidationComponentProps, state: UIComponentState, cssStyle: MSISDNValidationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
            <div style={cssStyle.getHeaderDivCSSStyle()}>
                <label style={cssStyle.getTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.number_validation)}</label>
                <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                    <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                </div>
                     
            </div>
            <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <MsisdnFloatingTextComponent maxLength={props.context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.numberComponent = item} id={"#mobilenumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.entercontactnumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
            </div>
            {/* <div style={{width:'100%',height:'20px',display:'flex',textAlign:'center',marginTop:'25px',marginLeft:'auto',marginRight:'auto'}}>
                 <label style={{width:'100%',height:'100%',lineHeight:'20px',color:'#003187',fontSize:'15px',fontWeight:300}}>
                     {"Resend OTP"}
                 </label>
            </div> */}
             <div style={{width:'100%',height:'40px',display:'flex',justifyContent:'center',marginTop:'50px',marginLeft:'auto',marginRight:'auto'}}>
                       
                        <div style={{width:'180px',height:'40px'}}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.verify)}/>
                        </div>
                </div>
            </div>
        );
    }


    onConfirmClick():void{
        (this.getUIComponentHandler() as MSISDNValidationComponentHandler).onConfirmClick();

    }

    onCloseClick():void{
         (this.getUIComponentHandler() as MSISDNValidationComponentHandler).onClosePopup();
    }
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/msisdnvalidation/msisdnvalidationview.tsx